import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-unlock-confirm-dialog',
  template: `
    <h1 mat-dialog-title>Déverrouiller les votes</h1>
    <div mat-dialog-content>
      <p style="color: #3d465a; margin-bottom: 16px;">
        Êtes-vous sûr de vouloir déverrouiller les votes ?
      </p>
      <div style="background-color: #fff3cd; border: 1px solid #ffc107; border-radius: 4px; padding: 12px;">
        <p style="margin: 0; color: #856404; font-size: 13px;">
          <strong>⚠️ Attention :</strong> Les positions seront réinitialisées en fonction du score bayésien actuel.
          Toutes les modifications manuelles de position seront perdues.
        </p>
      </div>
    </div>
    <div mat-dialog-actions align="end">
      <button mat-button (click)="onCancel()">Annuler</button>
      <button mat-flat-button color="warn" (click)="onConfirm()">Déverrouiller</button>
    </div>
  `,
  styles: []
})
export class UnlockConfirmDialogComponent {
  constructor(public dialogRef: MatDialogRef<UnlockConfirmDialogComponent>) {}

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}

